import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import API_ROUTES from "../../../api-routes";
import apiService from "../../../services/service";

const initialState = {};

export const fetchProccessId = createAsyncThunk(
  "processSlice/fetchProccessId",
  async (arg) => {
    // Support both old signature (id string) and new signature ({ id, skipCache })
    const id = typeof arg === "string" ? arg : arg.id;
    const skipCache = typeof arg === "object" ? arg.skipCache : false;
    const data = await apiService(API_ROUTES.FETCH_PROCESS, "GET", {
      replace: { id },
      skipCache,
    });
    return data;
  },
);

const processSlice = createSlice({
  name: "processSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProccessId.pending, (state) => {
        state.loadingprocess = true;
      })
      .addCase(fetchProccessId.fulfilled, (state, { payload }) => {
        state.processdata = payload.data;
        state.loadingprocess = false;
      })
      .addCase(fetchProccessId.rejected, (state) => {
        state.loadingprocess = false;
      });
  },
});
export default processSlice.reducer;
